import Axios from '@/plugins/axios.js'
import { smarturl,onlineUrl } from '@/utils/config';

// 公共数据字典 (批量)
export function getDictByType(params) {
  const config = {
    url: onlineUrl + '/seamark/common/data-dict/get-dict-by-type',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 公共数据字典
export function getSingleDictByType(key) {
  const config = {
    url: onlineUrl + '/seamark/common/data-dict/get-dict-by-type/' + key,
    method: 'GET',
  }
  return Axios(config)
}
// 公共数据字典 new 接口
export function getDictByTypeNew(key) {
  console.log('key',key)
  const config = {
    url: onlineUrl + '/mk-leads/common/dict/get-dict-by-type/' + key,
    method: 'GET',
  }
  return Axios(config)
}

// 获取协议列表
export function getAgreementListApi() {
  const config = {
    url: onlineUrl+'/biz-data/agreement/list',
    method: 'GET',
  }
  return Axios(config)
}
// 智能核价服务-校验用户配置数据是否已完成
export function activeUser() {
  const config = {
    url: `${smarturl}/swquote-online-v4/smart-pricing/user/check-config-status`,
    method: 'GET',
  }
  return Axios(config)
}
// 根据公司id获取经营模式
export function getBusinessModelApi(data) {
  const config = {
    url: `${onlineUrl}/mk-topping-api/supplier/get-business-model`,
    method: 'POST',
    data
  }
  return Axios(config)
}